export const SECTION_TYPE_SECONDARY = 'secondary'
export const SECTION_TYPE_SECONDARY_WARNING = 'secondaryWarning'
export const SECTION_TYPE_TERTIARY_WARNING = 'tertiaryWarning'
export const SECTION_TYPE_WARNING = 'warning'
export const SECTION_SUB_HEADER = 'section'

export const CHART_WIDTH = 70
export const CHART_HEIGHT = 45

export const PLACEHOLDER = 'PLACE_HOLDER';